export class WebCrypto {
  /**
   * @param {Parameters<typeof window.crypto.subtle.sign>} args
   * @returns {Promise<ArrayBuffer>}
   */
  static sign (...args) {
    return window.crypto.subtle.sign(...args);
  }

  /**
   * @param {Parameters<typeof window.crypto.subtle.importKey>} args
   * @returns {Promise<CryptoKey>}
   */
  static importKey (...args) {
    return window.crypto.subtle.importKey(...args);
  }
}
